export const shopifyTheme = {
  fontFamily:
    "-apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Helvetica Neue', Arial, 'sans-serif'",
  pallette: {
    main: "red",
    black: {
      main: "#000000",
    },
    silver: {
      main: "#EBEBEB",
      light: "#4D536B",
      primary: "#6B7496",
      secondary: "#C6CBE2",
      dark: "#D8DCEB",
      text: "#667085",
      disabled: "#BED1D5",
      disabledText: "#707998",
      disabledBg: "#0000000a",
    },
    dark: {
      main: "#101828",
    },
    blue: {
      main: "#0A1338",
      primary: "#182353",
      light: "#40a9ff",
      secondary: "#3B5998",
      link: "#00AEEF",
      border: "#1877F2",
      top: "#C5FFFD",
    },
    white: {
      main: "#FFFFFF",
      primary: "#fafafa",
      light: "#f1fcff",
    },
    green: {
      main: "#00A560",
      primary: "#77B747",
      light: "#303030",
      secondary: "#035E4C",
      disabled: "#C9FFD6",
      chip: "#cdffcd",
      circle: "#007f00",
      dark: "#148757",
      tooltip: "#37b850",
      free: "#d0feda",
    },
    red: {
      main: "#EF4444",
      primary: "#EF4444",
      secondary: "#E22C2A",
      error: "#8e0b21",
      light: "#fca5a5",
      border: "#8e0b21",
      danger: "#ff775d",
      background: "#fee8eb",
    },
    orange: {
      main: "#ff6347",
    },
    violet: {
      light: "#E9D7FE",
      main: "#6941C6",
    },
    yellow: {
      main: "#a17c0b",
      secondary: "#FDF7E7",
      light: "#fffaeb",
      border: "#FBBC04",
    },
  },
  fontSizes: [12, 14, 16, 18, 24, 32, 36, 72, 96],
  space: [0, 4, 8, 16, 32, 64, 128, 256],

  message: {
    color: "#8e0b21",
  },

  buttons: {
    main: {
      width: "auto",
      height: "auto",
      padding: "6px 12px",
      fontSize: "12px",
      smFontSize: "12px",
      lineHeight: "16px",
      weight: "550",
      color: "#FFFFFF",
      background: "#303030",
      border: "transparent",
      radius: "8px",
      shadow:
        "0rem -.0625rem 0rem .0625rem rgba(0, 0, 0, .8) inset, 0rem 0rem 0rem .0625rem rgba(48, 48, 48, 1) inset, 0rem .03125rem 0rem .09375rem rgba(255, 255, 255, .25) inset",

      hover: {
        background: "#1a1a1a",
        color: "#FFFFFF",
        border: "transparent",
      },
    },

    secondary: {
      width: "auto",
      height: "auto",
      padding: "6px 12px",
      fontSize: "12px",
      lineHeight: "16px",
      weight: "550",
      color: "#303030",
      background: "#ffffff",
      border: "transparent",
      radius: "8px",
      shadow:
        "0px -1px 0px 0px #b5b5b5 inset, 0px 0px 0px 1px rgba(0, 0, 0, 0.1) inset, 0px 0.5px 0px 1.5px #FFF inset",

      hover: {
        background: "#FAFAFAFF",
        color: "#303030",
        border: "transparent",
        shadow:
          "0rem -.0625rem 0rem 0rem #b5b5b5 inset, 0rem 0rem 0rem .0625rem rgba(0, 0, 0, .1) inset, 0rem .03125rem 0rem .09375rem #FFF inset",
      },
    },

    middle: {
      width: "auto",
      height: "auto",
      padding: "6px 12px",
      fontSize: "12px",
      lineHeight: "16px",
      weight: "550",
      color: "#FFFFFF",
      background: "#303030",
      radius: "8px",
      shadow:
        "0rem -.0625rem 0rem .0625rem rgba(0, 0, 0, .8) inset, 0rem 0rem 0rem .0625rem rgba(48, 48, 48, 1) inset, 0rem .03125rem 0rem .09375rem rgba(255, 255, 255, .25) inset",

      hover: {
        background: "#1a1a1a",
        color: "#FFFFFF",
      },
    },

    critical: {
      width: "auto",
      height: "auto",
      padding: "6px 12px",
      fontSize: "12px",
      lineHeight: "16px",
      weight: "550",
      color: "#FFFFFF",
      background: "#C70A24",
      radius: "8px",
      border: "none",
      shadow:
        "0rem -0.0625rem 0rem 0.0625rem rgba(142, 31, 11, 0.8) inset, 0rem 0rem 0rem 0.0625rem rgba(181, 38, 11, 0.8) inset, 0rem 0.03125rem 0rem 0.09375rem rgba(255, 255, 255, 0.349) inset",

      hover: {
        background: "#A30A24",
        color: "#FFFFFF",
        border: "none",
      },
    },

    submit: {
      width: "auto",
      height: "auto",
      padding: "6px 12px",
      fontSize: "12px",
      lineHeight: "16px",
      weight: "550",
      color: "#FFFFFF",
      background: "#303030",
      radius: "8px",
      shadow:
        "0rem -.0625rem 0rem .0625rem rgba(0, 0, 0, .8) inset, 0rem 0rem 0rem .0625rem rgba(48, 48, 48, 1) inset, 0rem .03125rem 0rem .09375rem rgba(255, 255, 255, .25) inset",
      border: "#303030",

      hover: {
        background: "#1a1a1a",
        color: "#FFFFFF",
        border: "#1a1a1a",
      },

      focus: {
        background: "#303030",
        color: "#FFFFFF",
        border: "none",
      },

      disabled: {
        background: "#303030",
        color: "#FFFFFF",
        border: "#303030",
        opacity: "0.3",
      },
    },

    modalButton: {
      width: "auto",
      height: "auto",
      padding: "6px 12px",
      fontSize: "12px",
      lineHeight: "16px",
      weight: "550",
      color: "#FFFFFF",
      background: "#303030",
      shadow:
        "0rem -.0625rem 0rem .0625rem rgba(0, 0, 0, .8) inset, 0rem 0rem 0rem .0625rem rgba(48, 48, 48, 1) inset, 0rem .03125rem 0rem .09375rem rgba(255, 255, 255, .25) inset",
      border: "0",
      radius: "8px",

      reset: {
        color: "#303030",
        background: "#ffffff",
        shadow:
          "0px -1px 0px 0px #b5b5b5 inset, 0px 0px 0px 1px rgba(0, 0, 0, 0.1) inset, 0px 0.5px 0px 1.5px #FFF inset",

        hover: {
          background: "#FAFAFAFF",
          color: "#303030",
          border: "transparent",
          shadow:
            "0rem -.0625rem 0rem 0rem #b5b5b5 inset, 0rem 0rem 0rem .0625rem rgba(0, 0, 0, .1) inset, 0rem .03125rem 0rem .09375rem #FFF inset",
        },
      },

      hover: {
        background: "#1a1a1a",
        color: "#FFFFFF",
      },

      focus: {
        background: "#1a1a1a",
        color: "#FFFFFF",
        border: "none",
      },

      disabled: {
        background: "#303030",
        color: "#FFFFFF",
        opacity: "0.3",
      },
    },

    startHere: {
      width: "auto",
      height: "auto",
      padding: "6px 12px",
      fontSize: "12px",
      lineHeight: "16px",
      weight: "550",
      background: "#303030",
      color: "#FFFFFF",
      border: "none",

      hover: {
        background: "#1a1a1a",
        color: "#FFFFFF",
        mainColor: "#FFFFFF",
        border: "none",
        borderColor: "transparent",
      },
    },

    coupon: {
      width: "auto",
      height: "auto",
      padding: "6px 12px",
      fontSize: "12px",
      lineHeight: "16px",
      weight: "550",
      color: "#FFFFFF",
      background: "#303030",
      border: "transparent",
      radius: "8px",
      shadow:
        "0rem -.0625rem 0rem .0625rem rgba(0, 0, 0, .8) inset, 0rem 0rem 0rem .0625rem rgba(48, 48, 48, 1) inset, 0rem .03125rem 0rem .09375rem rgba(255, 255, 255, .25) inset",

      hover: {
        background: "#1a1a1a",
        color: "#FFFFFF",
        border: "transparent",
      },
    },

    withIcon: {
      width: "auto",
      height: "auto",
      padding: "6px 12px",
      fontSize: "12px",
      lineHeight: "12px",
      weight: "550",
      color: "#FFFFFF",
      background: "#303030",
      border: "transparent",
      radius: "8px",
      shadow:
        "0rem -.0625rem 0rem .0625rem rgba(0, 0, 0, .8) inset, 0rem 0rem 0rem .0625rem rgba(48, 48, 48, 1) inset, 0rem .03125rem 0rem .09375rem rgba(255, 255, 255, .25) inset",

      hover: {
        background: "#1a1a1a",
        color: "#FFFFFF",
        border: "transparent",
      },
    },
  },
};
